"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTokenInput = void 0;
var isObject_1 = __importDefault(require("lodash/isObject"));
var Types_1 = require("./Types");
function isTokenInput(val) {
    return (0, isObject_1.default)(val) && val["dataSource"] === Types_1.DataSource.Token;
}
exports.isTokenInput = isTokenInput;
